export function canEdit(roleName, status) {
  return roleName && Role(roleName, status).isManager
}

export function canParticipate(roleName, status) {
  return (
    roleName &&
    !Role(roleName, status).isNotMember &&
    MembershipStatus(status).isActive
  )
}

export function canJoin(roleName, status) {
  return (
    roleName &&
    Role(roleName, status).isNotMember &&
    !MembershipStatus(status).isBlocked &&
    !MembershipStatus(status).isActive
  )
}

function Role(roleName, status) {
  const formattedRole = roleName?.toLowerCase()

  return {
    isMember: formattedRole === 'member' && MembershipStatus(status).isActive,
    isNotMember:
      formattedRole === 'not member' || !MembershipStatus(status).isActive,
    isManager: formattedRole === 'manager' && MembershipStatus(status).isActive,
  }
}

export function MembershipStatus(status) {
  const formattedStatus = status?.toLowerCase()
  return {
    isInvited: formattedStatus === 'invited',
    isApplied: formattedStatus === 'applied',
    isBlocked: formattedStatus === 'blocked',
    isActive: formattedStatus === 'active',
  }
}
